var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokerProLotto4DIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8955 9.18627C29.2879 9.18627 30.6233 9.73939 31.6078 10.724C32.5924 11.7085 33.1455 13.0439 33.1455 14.4363M38.3955 14.4363C38.3957 15.9677 38.061 17.4807 37.4147 18.8691C36.7683 20.2575 35.8262 21.4877 34.6541 22.4734C33.4821 23.4592 32.1087 24.1767 30.6301 24.5755C29.1515 24.9743 27.6035 25.0449 26.0948 24.7823C25.1095 24.6125 24.0665 24.8278 23.3595 25.5348L18.708 30.1863H14.7705V34.1238H10.833V38.0613H4.27051V33.1298C4.27051 32.085 4.68526 31.0823 5.42376 30.3455L16.797 18.9723C17.504 18.2653 17.7193 17.2223 17.5495 16.237C17.3014 14.8041 17.3536 13.3352 17.7029 11.9235C18.0521 10.5117 18.6909 9.18796 19.5786 8.03604C20.4663 6.88411 21.5836 5.92915 22.8597 5.23168C24.1359 4.53421 25.543 4.10943 26.9919 3.98427C28.4407 3.85911 29.8998 4.0363 31.2767 4.5046C32.6535 4.9729 33.918 5.72211 34.9901 6.70474C36.0622 7.68737 36.9185 8.88199 37.5047 10.2129C38.0909 11.5438 38.3943 12.982 38.3955 14.4363Z",
    stroke: "url(#paint0_linear_6578_38251)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6578_38251",
    x1: 9.92542,
    y1: 17.4587,
    x2: 45.1434,
    y2: 45.2281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokerProLotto4DIcon1);
export default __webpack_public_path__ + "static/media/jokerProLotto4dIcon1.03a663cc087d47ade2efdb40125a385d.svg";
export { ForwardRef as ReactComponent };